import React from "react";
import PropTypes from "prop-types";

import "./CircleLetterLogo.css";

/**
 *
 * @param logo
 * @param size
 * @param name
 * @param fontSize
 * @returns {Element}
 * @constructor
 */
const CircleLetterLogo = ({ logo, size = 40, name, fontSize }) => {
  const upperCaseName = name.toString().slice(0, 2).toUpperCase();
  const containerStyle = {
    width: size,
    height: size,
    fontSize: fontSize || size / 2.25,
  };

  return (
    <div className="circleBrandLogo" style={containerStyle}>
      {logo && typeof logo === "string" ? (
        <img src={logo} alt={name} style={{ width: size, height: size }} />
      ) : (
        <span>{upperCaseName}</span>
      )}
    </div>
  );
};

CircleLetterLogo.propTypes = {
  logo: PropTypes.string,
  size: PropTypes.number,
  name: PropTypes.string.isRequired,
  style: PropTypes.object,
  fontSize: PropTypes.number,
};

export default React.memo(CircleLetterLogo);
